export function validateErrorAndCheckArray(array) {
  if (array instanceof Error) {
    console.error('An error occurred:', array.message);
    return false;
  } else {
    if (Array.isArray(array)) {
      if (array?.length === 0) {
        console.warn('The array is empty.');
        return false;
      } else {
        console.log('The array is not empty.');
        return true;
      }
    } else {
      console.error('Invalid input. Expected an array.');
      return false;
    }
  }
}

export function ensureObjectProperty(obj, property, defaultValue) {
  try {
    if (obj && obj[property] !== undefined) {
      return obj[property];
    }
    return defaultValue;
  } catch (error) {
    console.error('Error while accessing property:', error);
    return defaultValue;
  }
}

export function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const intialDefaultValue = (selectedValue) => {
  const datas = selectedValue?.find((_el) => _el?.status === true);
  return datas ? datas.name : '';
};
export const feildDefaultValue = (selectedValue) => {
  const datas = selectedValue?.filter((_el) => _el?.status === true);
  return datas && datas.name;
};
